import Axios from "axios";
import {initUserForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initUsersCreate(){

    const userForm = initUserForm(document.querySelector('.user-form'));

    document.querySelector('.create-new-user-button').onclick = createNewUser;

    function createNewUser(){
        const userData = userForm.inputs();

        userForm.clearFeedbacks();

        loading();

        Axios.post(userForm.postUrl(),userData)
            .then(response => {
                handleAjaxSuccess(response,() => {
                    loading()
                    window.location = userForm.successUrl()
                })
            })
            .catch(handleAjaxError)
            .finally(stopLoading)
    }
}

export {initUsersCreate}
